import React, { useState } from 'react';
import Dropdown from './Dropdown'; // Assuming Dropdown is in the same 'components' folder

const FilterModal = ({ isOpen, onClose, onApply, premiseOptions, cityOptions }) => {
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedPremise, setSelectedPremise] = useState('');

  const handleApply = () => {
    onApply({ city: selectedCity, premise: selectedPremise });
    onClose();
  };

  const handleClearAll = () => {
    setSelectedCity('');
    setSelectedPremise('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        />
        
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-6 py-4">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Filter Records</h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">City</label>
                <Dropdown
                  options={cityOptions}
                  value={selectedCity}
                  onChange={setSelectedCity}
                  placeholder="Select City"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Premise</label>
                <Dropdown
                  options={premiseOptions}
                  value={selectedPremise}
                  onChange={setSelectedPremise}
                  placeholder="Select Premise"
                />
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleClearAll}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Clear All
              </button>
              <button
                onClick={handleApply}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;